import React from "react";
import { Link } from "react-router-dom";

const CurrentPage: React.FC<{ currentPage: number }> = ({ currentPage }) => (
  <span aria-current="page" className="page-numbers active">
    {currentPage}
  </span>
);

const Dots: React.FC = () => <span className="page-numbers dots">…</span>;

const Pagenation: React.FC<{
  currentPage: number;
  pageCount: number;
  baseUrl: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}> = ({ currentPage, pageCount, baseUrl, onClick }) => {
  if (pageCount <= 1) return null; // 1ページしかない時はページネーションは必要ない

  return (
    <>
      <nav className="navigation pagination" aria-label="ページ">
        <h2 className="screen-reader-text">ページナビゲーション</h2>
        <div className="nav-links">
          {/* [<] */}
          {currentPage > 1 ? (
            <Link
              to={`${baseUrl}${currentPage - 1}`}
              className="prev page-numbers"
              onClick={onClick}
            >
              &lt;
            </Link>
          ) : (
            ""
          )}
          {/* [1] */}
          {currentPage == 1 ? (
            <CurrentPage currentPage={currentPage} />
          ) : (
            <Link className="page-numbers" to={`${baseUrl}1`} onClick={onClick}
            >
              1
            </Link>
          )}
          {/* [...] */}
          {currentPage > 3 ? <Dots /> : ""}
          {/* 1ページ前 */}
          {currentPage > 2 ? (
            <Link className="page-numbers" to={`${baseUrl}${currentPage - 1}`} onClick={onClick}
            >
              {currentPage - 1}
            </Link>
          ) : (
            ""
          )}
          {/* 現在のページ（2ページ～最後の一つ前まで） */}
          {currentPage > 1 ? <CurrentPage currentPage={currentPage} /> : ""}
          {/* 1ページ後 */}
          {pageCount - currentPage > 1 ? (
            <Link className="page-numbers" to={`${baseUrl}${currentPage + 1}`} onClick={onClick}
            >
              {currentPage + 1}
            </Link>
          ) : (
            ""
          )}
          {/* [...] */}
          {pageCount - currentPage > 2 ? <Dots /> : ""}
          {/* 最後のページ */}
          {currentPage != pageCount ? (
            <Link className="page-numbers" to={`${baseUrl}${pageCount}`} onClick={onClick}
            >
              {pageCount}
            </Link>
          ) : (
            ""
          )}
          {/* [>] */}
          {currentPage != pageCount ? (
            <Link
              className="next page-numbers"
              to={`${baseUrl}${currentPage + 1}`}
              onClick={onClick}

            >
              &gt;
            </Link>
          ) : (
            ""
          )}
        </div>
      </nav>
    </>
  );
};

export default Pagenation;
